'use client'

import { useCallback } from 'react'

import { useAppSelector } from '@/lib/store'
import { selectPrivacySettings } from '@/lib/store/selectors'

import { pushFunnelEvent, type FunnelEvent } from './funnel-events'

export function useFunnelEvents() {
  const privacy = useAppSelector(selectPrivacySettings)
  const analyticsConsent = privacy?.cookieConsent?.analytics === true
  const push = useCallback(
    (evt: FunnelEvent) => pushFunnelEvent(evt, analyticsConsent),
    [analyticsConsent]
  )
  return { push }
}
